import { Component, input } from '@angular/core';
import { IconKlankvoetNormal } from '../../icons/i-klankvoet-normal';
import { IconKlankvoetStom } from '../../icons/i-klankvoet-stom';
import { RidCompressableKlankCard } from '../rid-compressable-klank-card/rid-compressable-klank-card';
import { TKey } from '../rid-syllabic-keyboard/rid-syllabic-keyboard.utils';

@Component({
  selector: 'rid-syllabic-card',
  imports: [RidCompressableKlankCard, IconKlankvoetNormal, IconKlankvoetStom],
  templateUrl: './rid-syllabic-card.html',
})
export class RidSyllabicCard {
  value = input.required<TKey>();
}
